import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import DOMPurify from "dompurify";
import { Modal as AntModal } from "antd";
import { PDFReader } from "reactjs-pdf-reader-custom";
import pdfpng from "../../../asset/imgs/pdfpng.png";
import { downloadIcon } from "../../../asset";
import styled from "styled-components";

const ActionImage = styled.img`
  width: 30px;
  height: 30px;
  cursor: pointer;
`;

export default function ViewLeaveReason(props) {
  const { reason, handleClose, show, data } = props;
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [loading, setLoading] = useState(true);

  function createMarkup() {
    return {
      __html: DOMPurify.sanitize(reason),
    };
  }

  const openDocument = (doc) => {
    setSelectedDocument(doc);
    setLoading(true);
  };

  const closeDocument = () => {
    setSelectedDocument(null);
  };

  const getFileName = (url) => {
    return url ? url.split('/').pop() : '';
  };

  const handleModalClose = () => {
    setSelectedDocument(null);
    handleClose();
  };

  return (
    <>
      <AntModal
        title=""
        footer={false}
        centered
        className="upload-modal leave-details-modal"
        visible={show}
        onCancel={handleModalClose}
        width={600}
      >
        <Modal.Header>
          <Modal.Title>
            <b>LEAVE DETAILS</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="confirmation">
          {/* Reason Section */}
          <div className="leave-reason-section">
            <h6 className="section-title">
              <i className="fa fa-file-text-o mr-2 mb-2" aria-hidden="true"></i>
              Reason
            </h6>
            <div
              className="reason-content"
              dangerouslySetInnerHTML={createMarkup()}
            />
          </div>

          {/* Documents Section */}
          {data && data.length > 0 && (
            <div className="leave-documents-section mt-3">
              <hr />
              <h6 className="section-title">
                <i className="fa fa-paperclip mr-2 mb-2" aria-hidden="true"></i>
                Attachments ({data.length})
              </h6>
              <div className="document-list">
                {data.map((doc, index) => {
                  const isPdf = doc.toLowerCase().endsWith(".pdf");
                  const isImage =
                    doc.toLowerCase().endsWith(".jpeg") ||
                    doc.toLowerCase().endsWith(".jpg") ||
                    doc.toLowerCase().endsWith(".png");

                  if (!isPdf && !isImage) return null;

                  return (
                    <div
                      key={index}
                      className="document-item d-flex justify-content-between align-items-center mb-2 p-2"
                      style={{
                        backgroundColor: "#f8f9fa",
                        borderRadius: "8px",
                        border: "1px solid #e9ecef"
                      }}
                    >
                      <div className="d-flex align-items-center">
                        {isPdf ? (
                          <img
                            src={pdfpng}
                            alt={`pdfThumbnail_${index}`}
                            style={{ width: "30px", height: "30px", cursor: "pointer" }}
                            onClick={() => openDocument(doc)}
                          />
                        ) : (
                          <img
                            src={doc}
                            alt={`imageThumbnail_${index}`}
                            style={{ width: "30px", height: "30px", objectFit: "cover", cursor: "pointer", borderRadius: "4px" }}
                            onClick={() => openDocument(doc)}
                          />
                        )}
                        <span className="ml-2 text-truncate" style={{ maxWidth: "300px" }}>
                          {getFileName(doc)}
                        </span>
                      </div>
                      <div className="d-flex align-items-center">
                        <span
                          onClick={() => openDocument(doc)}
                          style={{ cursor: "pointer" }}
                          title="View Document"
                        >
                          <i className="fa fa-eye blue ml-2" />
                        </span>
                        <a
                          href={doc}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="ml-3"
                          title="Download"
                        >
                          <ActionImage
                            src={downloadIcon}
                            alt={`downloadIcon_${index}`}
                          />
                        </a>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </Modal.Body>
      </AntModal>

      {/* Document Viewer Modal */}
      <AntModal
        title=""
        footer={false}
        centered
        className="sm_modal1"
        visible={selectedDocument !== null}
        onCancel={closeDocument}
        zIndex={1100}
      >
        <Modal.Body
          className={`view_pdf ${loading && selectedDocument?.toLowerCase().endsWith(".pdf") ? " d-flex justify-content-center align-items-center" : ""}`}
        >
          {loading &&
            selectedDocument &&
            (selectedDocument.toLowerCase().endsWith(".pdf")) && (
              <div className="snippet" data-title="dot-elastic">
                <div className="stage">
                  <div className="dot-elastic"></div>
                </div>
              </div>
            )}
          {selectedDocument && (
            <>
              {(selectedDocument.toLowerCase().endsWith(".pdf")) && (
                <PDFReader
                  url={selectedDocument}
                  showAllPage={true}
                  onDocumentComplete={() => setLoading(false)}
                  width="700"
                />
              )}
              {(selectedDocument.toLowerCase().endsWith(".jpeg") ||
                selectedDocument.toLowerCase().endsWith(".jpg") ||
                selectedDocument.toLowerCase().endsWith(".png")) && (
                  <div className="d-flex justify-content-center">
                    <img
                      src={selectedDocument}
                      alt="document"
                      style={{ maxWidth: "100%", maxHeight: "70vh" }}
                    />
                  </div>
                )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="submit_button_margin">
          <div className="mt-4">
            <button
              type="button"
              onClick={closeDocument}
              className="btn btn-primary cm_btn2"
            >
              Close
            </button>
          </div>
        </Modal.Footer>
      </AntModal>
    </>
  );
}
